import { useQuery } from "@tanstack/react-query";
import { getSNSFollowers } from "../services/api/portfolios/getSNSFollowers";

export const useGetSNSFollowers = (profileId: string) => {
  const followersData = useQuery(
    ["sns_followers", profileId],
    ({ signal }) => getSNSFollowers(profileId, signal),
    { cacheTime: 0, retry: false }
  );

  return {
    followersData: followersData.data,
    isLoading: followersData.isLoading,
    isError: followersData.isError,
  };
};
